import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import './ProjectTitle.scss'

const ProjectTitle = ({ ui }) => {
  const ProjectTitle = ui.ProjectTitle;
  const [isVisible, setIsVisible] = useState(true); // initially visible
// console.log('projectTitle ', ProjectTitle);

 return ReactDOM.createPortal(
  <h3 id="">
    {ProjectTitle}
  </h3>,
  document.getElementById("ProjectTitle")
  
);
};

export default ProjectTitle;
